module.exports = __webpack_public_path__ + "static/media/ephippiger_ephippiger_006_APA.6325297d.mp3";